import http from './http';

const getClientesBoletos = (dadosCliente) => http.post('/clientesBoletos', dadosCliente);

export default getClientesBoletos;
